import React from 'react';

type Size = 'sm' | 'md' | 'lg';

interface Props {
  size?: Size;
  centered?: boolean;
  label?: string;
}

const sizeClasses: Record<Size, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]',
};

const LoadingSpinner: React.FC<Props> = ({
  size = 'md',
  centered = false,
  label,
}) => {
  const wrapperCls = centered
    ? 'flex flex-col items-center justify-center gap-3 py-12'
    : 'inline-flex items-center gap-2';
  return (
    <div data-testid="spinner-wrapper" className={wrapperCls}>
      <span
        role="status"
        aria-label={label ?? 'Loading'}
        className={`animate-spin rounded-full border-brand-600 border-t-transparent ${sizeClasses[size]}`}
      />
      {label && <span className="text-sm text-slate-600">{label}</span>}
    </div>
  );
};

export default LoadingSpinner;
